import React from 'react';
import { Row, Col } from "react-bootstrap";
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Register the required Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

// ---------------------------------------------------
// Helper functions from the original script
// ---------------------------------------------------

const processLabels = (labels, maxLength = 16) => {
    return labels.map(label => {
        if (typeof label === 'string' && label.length > maxLength) {
            const words = label.split(' ');
            const newLabel = [];
            let currentLine = '';
            words.forEach(word => {
                if ((currentLine + word).length > maxLength) {
                    newLabel.push(currentLine.trim());
                    currentLine = '';
                }
                currentLine += word + ' ';
            });
            newLabel.push(currentLine.trim());
            return newLabel;
        }
        return label;
    });
};

const tooltipTitleCallback = (tooltipItems) => {
    const item = tooltipItems[0];
    let label = item.chart.data.labels[item.dataIndex];
    if (Array.isArray(label)) {
        return label.join(' ');
    }
    return label;
};

// ---------------------------------------------------
// Common chart options and colors
// ---------------------------------------------------

const chartColors = ['#008ffb', '#00e396', '#feb019', '#ff4560', '#775dd0', '#00b4d8'];

const commonChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'bottom',
            labels: {
                color: '#b2d8d8', 
                font: { size: 12}
            }
        },
        tooltip: {
            backgroundColor: '#03045E',
            titleColor: '#CAF0F8',
            bodyColor: '#ADE8F4',
            callbacks: {
                title: tooltipTitleCallback
            }
        }
    }
};

// ---------------------------------------------------
// React Component for Charts
// ---------------------------------------------------

const DoughnutCharts = () => {
    // Data for the Token Allocation Chart
    const tokenAllocationData = {
        labels: processLabels(['PreSale', 'Public Sale', 'LP', 'Projects Pool', 'Team']),
        datasets: [{
            label: 'Token Allocation',
            data: [25, 17, 25, 28, 5],
            backgroundColor: chartColors,
            borderColor: '#FFFFFF',
            borderWidth: 0.25
        }]
    };

    // Data for the Tax Distribution Chart
    const taxDistributionData = {
        labels: processLabels(['RR Pool', 'Sovereign Chest', 'Development', 'Bonus Pool', 'Burn','Cerulean Vault']),
        datasets: [{
            label: 'Tax Distribution',
            data: [20, 10, 25, 30, 10, 5],
            backgroundColor: chartColors,
            borderColor: '#FFFFFF',
            borderWidth: 0.25
        }]
    };

    return (
       <Row>
        <Col>
            <h2 className="text-xl font-semibold mb-4 text-center text-blue-800">Token Allocation</h2>
            <div style={{ height: '300px' }}>
                <Doughnut data={tokenAllocationData} options={commonChartOptions} />
            </div>
        </Col>
        <Col>
            <h2 className="text-xl font-semibold mb-4 text-center text-blue-800">Tax Distribution</h2>
            <div style={{ height: '300px' }}>
                <Doughnut data={taxDistributionData} options={commonChartOptions} />
            </div>

        </Col>
        </Row>
    );
};

export default DoughnutCharts;